export default {
  sideBySideV2: {
    container: {
      backgroundColor: 'background',
      flexDirection: ['column', 'column', 'column', 'row'],
      alignItems: ['', '', '', 'stretch'],
      padding: '2rem 0'
    },
    content: {
      flexDirection: 'column',
      padding: [4, '', '', 8],
      width: ['100%', '100%', '100%', '40%'],
      justifyContent: 'center',
      textAlign: 'center',
      alignItems: 'center',
      a: {
        display: 'flex',
        width: 'fit-content'
      }
    },
    subtitle: {
      fontWeight: 6,
      marginBottom: 3
    },
    title: {
      fontSize: 6,
      marginBottom: 3
    },

    ctaButton: {
      padding: 3,
      marginTop: 5,
      border: 'solid 2px',
      borderColor: 'primary',
      color: 'light',
      width: 'max-content',
      textTransform: 'uppercase',
      backgroundColor: 'primary',
      fontWeight: 'bold',
      '&:hover': {
        backgroundColor: 'secondary'
      }
    },

    text: {
      lineHeight: '1.75',
      whiteSpace: 'break-spaces'
    },

    imageContainer: {
      width: ['100%', '100%', '100%', '60%'],
      '.lazyload-wrapper': {
        display: 'flex'
      }
    },
    image: {
      width: ['100%', '100%', '100%', '50%'],
      margin: ['0.5rem', '', 'unset'],
      marginLeft: ['0.5rem', '', '1rem', ''],
      objectFit: 'cover',
      // height: '100%',
      maxHeight: '60vw'
    }
  }
}
